import { Injectable } from '@angular/core';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { take, tap } from 'rxjs/operators';
import { InvoicesRequest } from '../SicorService/RequestObject/InvoicesRequest';
import { Bill } from '../../models/Bill';
import { AppUserInvoiceDwl } from '../SicorService/RequestObject/AppUserInvoiceDwl';
import * as moment from 'moment';
import { GlobalMethodsService } from '../global-methods.service';
import { NavigationService } from './navigation.service';
import { ModalController } from '@ionic/angular';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillService {

  constructor(private sicorAPI: SicorApiService,
    public gms: GlobalMethodsService,
    private navigation: NavigationService,
    private modalCtrl: ModalController,
    private translate: TranslateConfigService) { }

  public async isAppuserInvoices(user: string, s_ins: number, start_dt: string, end_dt: string): Promise<Bill[]> {
    const requestParams: InvoicesRequest = new InvoicesRequest(user, s_ins, start_dt, end_dt);
    let bills: Bill[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.isAppuserInvoicesRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'billsModal');
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                resolve(undefined);
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                var billsList: Bill[] = [];
                if (res.resultSet.length === 1 && res.resultSet[0].error != null && res.resultSet[0].error === 0) {
                  resolve(billsList);
                  return;
                }
                res.resultSet.forEach(bill => {
                  bill.show_date = moment(bill.invoice_date).locale('es').format('MMMM YYYY')
                  bill.invoice_date = moment(bill.invoice_date.replace(/ /g, "T")).format("DD/MM/YYYY");
                  bill.due_date = moment(bill.due_date.replace(/ /g, "T")).format("DD/MM/YYYY");
                  billsList.push(bill);
                });
                // bills = res.resultSet;
                resolve(billsList);
              }
            }
          }, error: e => {
            resolve(null);
          }
        })
      ));
    });
  }

  public async gAppuserInvoiceDwl(user: string, invoice: string): Promise<string> {
    const requestParams: AppUserInvoiceDwl = new AppUserInvoiceDwl(user, invoice);
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.gAppuserInvoiceDwlRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0].error != null && res.resultSet[0].error === 0) {
              resolve(res.resultSet[0].message);
            } else {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'billsModal');
                resolve(undefined);
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                this.modalCtrl.dismiss(false, '', 'reportFailureModal');
                resolve(null)
              }
            }
          }, error: e => {
            this.modalCtrl.dismiss(false, '', 'loadSpinner');
            this.modalCtrl.dismiss(false, '', 'reportFailureModal');
            resolve(null);
          }
        })
      ));
    });
  }

  public async gAppuserViewInvoice(user: string, invoice: string): Promise<string> {
    const requestParams: AppUserInvoiceDwl = new AppUserInvoiceDwl(user, invoice);
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.gAppuserViewInvoiceRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0] != null) {
              if (res.resultSet[0].error != null) {
                if (res.resultSet[0].error === 401) {
                  this.modalCtrl.dismiss(false, '', 'billsModal');
                  await this.navigation.logout();
                  await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                    'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                  resolve(undefined);
                }
                else {
                  resolve("");
                }
              } else {
                if (res.resultSet[0].invoice != null && res.resultSet[0].inv_pdf != null) {
                  resolve(res.resultSet[0].inv_pdf);
                }
                else {
                  resolve("")
                }
              }
            } else {
              resolve("");
            }
          }, error: e => {
            resolve("");
          }
        })
      ));
    });
  }
}
